import { render, staticRenderFns } from "./head.vue?vue&type=template&id=01ed4db0&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "./head.vue?vue&type=style&index=0&id=01ed4db0&prod&scoped=true&lang=css"
import style1 from "./head.vue?vue&type=style&index=1&id=01ed4db0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed4db0",
  null
  
)

export default component.exports